import { useState } from 'react';
import './PostComposer.css';

function NotificationComposer({ backendUrl }) {

  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [status, setStatus] = useState('');
  const [sending, setSending] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!title.trim() || !description.trim()) {
      setStatus('Please add a title and description.');
      return;
    }

    try {
      setSending(true);
      setStatus('Sending notification...');

      const formData = new FormData();
      formData.append("title", title.trim());
      formData.append("description", description.trim());

      const response = await fetch(`${backendUrl}/send_notification`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error("Notification send failed");
      }

      setStatus('Notification sent successfully');
      setTitle('');
      setDescription('');

    } catch (err) {
      console.error(err);
      setStatus('Failed to send notification');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="card post-card">
      <form className="composer-form" onSubmit={handleSubmit}>

        <label className="composer-field">
          <span>Notification title</span>
          <input
            type="text"
            value={title}
            onChange={(event) => setTitle(event.target.value)}
            disabled={sending}
          />
        </label>

        <label className="composer-field">
          <span>Description</span>
          <textarea
            value={description}
            onChange={(event) => setDescription(event.target.value)}
            rows={4}
            disabled={sending}
          />
        </label>

        {status && <p className="status">{status}</p>}

        <button type="submit" disabled={sending}>
          {sending ? "Sending..." : "Send notification"}
        </button>

      </form>
    </div>
  );
}

export default NotificationComposer;

